<template>
  <div class="flex" @click.stop="model = !model">
    <div
      class="rounded cursor-pointer shrink-0 p-1"
      :class="[
        ...borderColor,
        ...bgColor,
        ...size,
        disabled ? 'opacity-50 pointer-events-none' : ''
      ]"
    >
      <div class="w-full h-full flex items-center justify-center">
        <l-icon v-if="half" name="minus" class="text-n-0" small />
        <l-icon v-else-if="model" name="check" class="text-n-0" small />
      </div>
    </div>
    <div
      v-if="label || $slots.default"
      class="ml-2 cursor-pointer text-n-600 dark:text-n-0"
      :class="{ 'leading-6': !small }"
    >
      <slot> {{ label }} </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LIcon from './LIcon.vue'

interface Props {
  small?: boolean
  disabled?: boolean
  half?: boolean
  label?: string
  error?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  small: false,
  disabled: false,
  half: false,
  error: false,
  label: ''
})

const model = defineModel<boolean>({
  default: false
})

const bgColor = computed(() => {
  if (model.value || props.half) {
    return ['bg-v-500 dark:bg-v-300']
  }
  if (props.error) {
    return ['bg-r-500/20']
  }
  return ['bg-n-0 dark:bg-transparent']
})

const borderColor = computed(() => {
  if (model.value || props.half) {
    return ['border-none']
  }
  if (props.error) {
    return ['border', 'border-r-500']
  }

  return ['border', 'border-n-300']
})

const size = computed(() => {
  if (props.small) {
    return ['w-4', 'h-4']
  }
  return ['w-5', 'h-5']
})
</script>
